import React, { useEffect, useState } from "react";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import revenueIcon from "./../../../assets/revenue.svg";
import hoursIcon from "./../../../assets/sand_timer.svg";
import increaseRevenueIcon from "./../../../assets/increase_revenue.svg";
import { NumericFormat } from "react-number-format";
import Card from "../../Card/Card";
import useRoi from "../../../Context/RoiContex";
import { calculateEnbSavings } from "../../../api/ApiService";

function SaveStaffHours() {
  const [savingsData, setSavingsData] = useState({
    monthlyHoursSavedFromVerification: 0,
    monthlyCostSavings: 0,
    annualCostSavings: 0,
  });

  // saveStaffHoursInputValues: {
  //   avgEbVerificaitonPerMonth: 0,
  //   perProviderCost: 0,
  // },

  const {
    numberOfProviders,
    updateAutomatedSavingsData,
    saveStaffHoursInputValues,
    updateSaveStaffHoursInputValues,
  } = useRoi();
  const [avgHourEb, setAvgHourEb] = useState(saveStaffHoursInputValues?.avgEbVerificaitonPerMonth);
  const [providerCostEb, setProviderCostEb] = useState(saveStaffHoursInputValues?.perProviderCost);

  useEffect(() => {
    const getInitialData = async () => {
      try {
        const param = {
          averageNumberOfHoursSpentInManualVerification: avgHourEb,
          perProviderCostEBServiceMonthly: providerCostEb,
          numberOfProviders: numberOfProviders,
        };
        const response = await calculateEnbSavings(param);
        updateAutomatedSavingsData(response);
        setSavingsData(response);
      } catch (error) {
        console.error("Error fetching staff data:", error);
      } finally {
      }
    };
    setTimeout(() => {
      getInitialData();
    }, 0);
  }, [avgHourEb, providerCostEb, numberOfProviders]);

  return (
    <div className="mx-0" style={{ marginLeft: "6px" }}>
      <div className="w-full ">
        <div className="flex justify-between h-[62px] items-center mt-6 number-hours-spent">
          <label htmlFor="collecton-agency" className="text-lg text-[#1A1A1A] font-semibold">
            Number of hours spent in manual insurance eligibility verification per month
          </label>
          <NumericFormat
            id="avg-hours"
            name="avg-hours"
            value={avgHourEb}
            onValueChange={(values) => {
              const { value } = values;
              setAvgHourEb(value);
              updateSaveStaffHoursInputValues({
                ...saveStaffHoursInputValues,
                avgEbVerificaitonPerMonth: parseInt(value),
              });
            }}
            allowNegative={false}
            className="ha-roi-form-input"
          />
        </div>
        <div style={{ position: "relative", top: "15px" }}>
          <Slider
            min={0}
            max={5000}
            value={avgHourEb}
            trackStyle={{ backgroundColor: "#147D6E" }}
            handleStyle={{
              borderColor: "#147D6E",
              backgroundColor: "#147D6E",
            }}
            onChange={(value) => {
              setAvgHourEb(value);
              updateSaveStaffHoursInputValues({
                ...saveStaffHoursInputValues,
                avgEbVerificaitonPerMonth: parseInt(value),
              });
            }}
          />
        </div>
      </div>
      <div className="w-full">
        <div
          className="flex justify-between h-[62px] items-center my-1"
          style={{ marginTop: "25px" }}
        >
          <label htmlFor="collecton-agency" className="text-lg text-[#1A1A1A] font-semibold">
            Monthly cost of E&B services per provider (if any)
          </label>
          <NumericFormat
            id="collecton-agency"
            name="collecton-agency"
            value={providerCostEb}
            onValueChange={(values) => {
              const { value } = values;
              setProviderCostEb(value);
              updateSaveStaffHoursInputValues({
                ...saveStaffHoursInputValues,
                perProviderCost: parseInt(value),
              });
            }}
            prefix="$"
            allowNegative={false}
            className="ha-roi-form-input"
          />
        </div>
        <div style={{ position: "relative", top: "10px" }}>
          <Slider
            min={0}
            max={100}
            value={providerCostEb}
            trackStyle={{ backgroundColor: "#147D6E" }}
            handleStyle={{
              borderColor: "#147D6E",
              backgroundColor: "#147D6E",
            }}
            onChange={(value) => {
              setProviderCostEb(value);
              updateSaveStaffHoursInputValues({
                ...saveStaffHoursInputValues,
                perProviderCost: parseInt(value),
              });
            }}
          />
        </div>
      </div>
      <p className="text-xl font-bold mt-6" style={{marginTop: "35px"}}>By automating the E&B process, you save:</p>

      <div className="flex  gap-5 w-full mt-4 second-second-card">
        <Card
          icon={hoursIcon}
          message="hours per month for your staff"
          value={savingsData.monthlyHoursSavedFromVerification}
          type="HOUR"
          color="#71B254"
        />
        <Card
          icon={increaseRevenueIcon}
          message="annually"
          value={savingsData.annualCostSavings}
          color="#147D6E"
        />
      </div>
    </div>
  );
}

export default SaveStaffHours;
